<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>服务类型</label>
          <el-select v-model="serviceType" placeholder="Select" class="select-item">
            <el-option v-for="item in serviceTypeArray" :key="item.serviceType" :label="item.name" :value="item.serviceType">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange title="消费时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>赠送项目</label>
          <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
<!--          <el-checkbox v-model="limitState" style="margin-left: 8px"><span style="white-space: nowrap">有限制</span></el-checkbox>-->
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
        <div class="dialog-input-btn">
<!--          <ElButtons type="success" icon="Plus"  @click="checkDetail(-1)"> 添加 </ElButtons>-->
<!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="giveTime" label="赠送时间"/>
      <el-table-column property="projectAllContent" label="服务类型">
        <template #default="scope">
          {{scope.row.serviceType == 1?'洗澡项目':scope.row.serviceType == 2?'增值项目':scope.row.serviceType == 5?'其他':''}}
        </template>
      </el-table-column>
      <el-table-column property="name" label="赠送项目" />
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getProjectGivePageList, listProjectServiceType,} from '@/api/url';
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import UserInfo from "@/components/User/userInfo"
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents, UserInfo},
  data() {
    return {
      userId: this.value.userId,
      pageDataList: [],
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      sexArray: [
        {label: '不限', value: -1},
        {label: '未知', value: 0},
        {label: '男', value: 1},
        {label: '女', value: 2}
      ],
      sex: -1,

      serviceTypeArray: [
        {name: '不限', serviceType: -1}
      ],
      serviceTypeList: [],
      serviceType: -1,

      //消费时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchTypeList: [
        {label : '赠送项目', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      limitState: true,
    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getBindingTime(val) {
      this.bindingStartTime = val[0];
      this.bindingEndTime = val[1];
      // console.log(val)
    },
    getBindingCheck(val) {
      this.isBindingChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['state'] = this.state;
      param['isUse'] = -1;
      param['type'] = 2;
      param['serviceType'] = this.serviceType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getProjectGivePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getServiceType() {
      getFormData(listProjectServiceType).then((data) => {
        if(data.code == 200) {
          this.serviceTypeList = data.data.filter(item => item.serviceType == 1 || item.serviceType == 2 || item.serviceType == 5)
          this.serviceTypeArray = this.serviceTypeArray.concat(this.serviceTypeList)
        }
      })
    }

  },
  mounted() {
    this.getPage();
    this.getServiceType()
  }
}
</script>

<style>

</style>
